import { render, staticRenderFns } from "./addMotion.vue?vue&type=template&id=60e9d912&scoped=true&"
import script from "./addMotion.vue?vue&type=script&lang=tsx&"
export * from "./addMotion.vue?vue&type=script&lang=tsx&"
import style0 from "./addMotion.vue?vue&type=style&index=0&id=60e9d912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9d912",
  null
  
)

export default component.exports